import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

const StyledButton = styled.button`
  background:#60eaad;
  border-radius: 60px;
  color:#30576e;
  display: inline-block;
  font-size: .9em;
  font-weight: 400;
  min-width: 8rem;
  padding: .5rem 2rem;
  text-align: center;
  transition: background .15s linear;
  line-height: 1.45em;
  border: 0;
`


const Button = ({
  type, label, onClick, disabled, className
}) => (
  <StyledButton
    className={className}
    type={type}
    onClick={onClick}
    disabled={disabled}
  >
    {label}
  </StyledButton>
)

Button.propTypes = {
  type: PropTypes.string,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  className: PropTypes.string
}

Button.defaultProps = {
  type: 'button',
  onClick: () => {},
  disabled: false,
  className: null
}

export default Button